import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './AlbumList.css';

const getCardDescription = (album) => (
    album.shortDescription || album.description || ''
);

const getActivityCount = (album) => (
    Array.isArray(album.activities) ? album.activities.length : 0
);

export default function AlbumList() {
    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAlbums();
    }, []);

    const fetchAlbums = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/albums`,
                { withCredentials: true }
            );
            setAlbums(response.data.albums || []);
            setError('');
        } catch (err) {
            console.error('Error fetching albums:', err);
            setError('Kunne ikke laste album');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="alb-list-loading">Laster album…</div>;
    }

    return (
        <div className="alb-list">
            <div className="alb-list-container">
                <div className="alb-list-top">
                    <Link to="/" className="alb-list-back">
                        <i className="fas fa-arrow-left" aria-hidden="true" />
                        Tilbake til hovedsiden
                    </Link>
                </div>

                <header className="alb-list-header">
                    <h1>Alle album</h1>
                    <p>Samlinger av aktiviteter – finn økter gruppert etter tema.</p>
                </header>

                {error && <div className="alb-list-error">{error}</div>}

                <div className="alb-list-grid">
                    {albums.length > 0 ? (
                        albums.map((album) => {
                            const description = getCardDescription(album);
                            const activityCount = getActivityCount(album);
                            const isPublic = album.isPublic === 1 || album.isPublic === true;

                            return (
                                <Link
                                    key={album.idalbums}
                                    to={`/albums/${album.idalbums}`}
                                    className="alb-list-card"
                                >
                                    <div className="alb-list-card-media">
                                        <i className="fas fa-compact-disc" aria-hidden="true" />
                                        {activityCount > 0 && (
                                            <span className="alb-list-card-badge">
                                                {activityCount} {activityCount === 1 ? 'aktivitet' : 'aktiviteter'}
                                            </span>
                                        )}
                                        {!isPublic && (
                                            <span className="alb-list-card-badge alb-list-card-badge--draft">
                                                Utkast
                                            </span>
                                        )}
                                    </div>
                                    <div className="alb-list-card-body">
                                        <h2>{album.name}</h2>
                                        {description && (
                                            <p className="alb-list-card-desc">{description}</p>
                                        )}
                                        <div className="alb-list-card-meta">
                                            <span className="alb-list-pill">
                                                <i className="fas fa-list" aria-hidden="true" />
                                                {activityCount} {activityCount === 1 ? 'aktivitet' : 'aktiviteter'}
                                            </span>
                                            {isPublic ? (
                                                <span className="alb-list-pill">
                                                    <i className="fas fa-globe" aria-hidden="true" />
                                                    Publisert
                                                </span>
                                            ) : (
                                                <span className="alb-list-pill alb-list-pill--draft">
                                                    <i className="fas fa-lock" aria-hidden="true" />
                                                    Utkast
                                                </span>
                                            )}
                                        </div>
                                        <span className="alb-list-card-cta">
                                            Se album
                                            <i className="fas fa-arrow-right" aria-hidden="true" />
                                        </span>
                                    </div>
                                </Link>
                            );
                        })
                    ) : (
                        <p className="alb-list-empty">Ingen album funnet</p>
                    )}
                </div>
            </div>
        </div>
    );
}
